import { render } from "./TaxonomiesList.vue?vue&type=template&id=84ac91cc"
import script from "./TaxonomiesList.vue?vue&type=script&lang=js"
export * from "./TaxonomiesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__